export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11486.b82e4a3f.jpg";